var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMeiju)?_c('div',{staticClass:"navigationBar"},[(_vm.name!='美书' || _vm.from === 'control')?_c('div',{staticClass:"return",on:{"click":_vm.goblack}},[_c('i',{staticClass:"icon iconfont icon-fanhui"})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"title2"},[_vm._v(_vm._s(_vm.parentToChild))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92d028a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigationbar.vue
// module id = null
// module chunks = 